import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments,fetchServiceRequestFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';
import {sortDocumentsList} from "../../helpers/CommonHelpers"
class ServiceRequestDocuments extends Component {
  componentDidMount() {
    const { serviceRequest, onFetchFaqsNotesDocuments, clearSearch } = this.props;
    onFetchFaqsNotesDocuments(serviceRequest.id);
    clearSearch();
  }

  onSave = async (document) => {
    this.props.onStartFormLoading();
    let image = null
    if(document && document.image && document.image.length > 0 && document.image[0].path){
      let path = document.image[0].path;
        let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
        image =  await upload(document.image[0], newFileName.replace(/ /g,''));
      document = document = {...document,image, name: document.name || newFileName}
    }

    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.serviceRequest.id,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.id
    }
   this.props.onSaveFaqsNotesDocuments(data)
  }
  onDeleteFaqsNotesDocuments(document){
    document.Type = 'DOCUMENTS';
    this.props.onDeleteFaqsNotesDocuments(document)
  }
  render() {
    const { documents, serviceRequest, setSearch, loader } = this.props;
    
    const sortDocuments = sortDocumentsList(documents)

    return (
      loader ? <Loader /> :
      <Documents
        breadcrumb={serviceRequest.number}
        documents={sortDocuments}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Photos & Documents"}
        from={"Service Request"}
        disableGrouping={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  loader: selectPRLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments:fetchServiceRequestFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestDocuments);
